import { Container, Row, Col } from '@ui/wrapper'
import Heading from '@ui/heading'
import Text from '@ui/text'
import SectionTitle from '@ui/section-title'
import { ContactInfoWrapper } from './style'

const ContactArea = ({ data }) => {
  return (
    <ContactInfoWrapper>
      <Container>
        {data?.section_title && (
          <SectionTitle
            mb={['30px', null, '53px']}
            layout={2}
            textAlign="left"
            title={data.section_title?.title}
            subtitle={data.section_title?.subtitle}
          />
        )}
        <Row>
          {data?.items?.map((info) => (
            <Col lg={4} key={info.id} mb="30px">
              {info.title && (
                <Heading as="h5" mb="20px">
                  {info.title}
                </Heading>
              )}
              {info.texts &&
                info.texts.map((text, i) => (
                  <Text
                    key={i}
                    mb="7px"
                    dangerouslySetInnerHTML={{
                      __html: text.content
                    }}
                  />
                ))}
            </Col>
          ))}
        </Row>
      </Container>
    </ContactInfoWrapper>
  )
}

export default ContactArea
